import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { connect } from 'react-redux';
import { CheckboxWithLabel, Button, ButtonSize, ButtonShape, ButtonVariant, IconName, IconSize, CheckboxWithLabelVerticallyAlign, } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { makeGetProductCompareInformation, makeGetIsCompareProduct, makeGetSelectedSku, } from '../../redux/product/selectors/ProductSelector';
import compareActions from '../../redux/compare/actions/CompareActions.creators';
import { PRODUCT_URL_PREFIX } from '../../constants/ProductConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { makeGetCompareItems } from '../../redux/compare/selectors/CompareSelectors';
import { useAemConfig } from '@as-react/common-components';
const ProductCompareSelectorContainer = ({ product: { brand, seoUrl, colorId, productId, productCode, title, image, colorDescription, sizes, gender, buyingGroup, productQualifier, brandValue, }, isCompareProduct, selectedSku, compareItems, updateCompareList, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { rootWithLanguageSuffix, root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    const selectedSize = sizes === null || sizes === void 0 ? void 0 : sizes.find((size) => size.sku === selectedSku);
    const compareProduct = {
        id: productId,
        color: colorId,
        url: `${rootWithLanguageSuffix}/${PRODUCT_URL_PREFIX}${seoUrl.indexOf('/') === 0 ? '' : '/'}${seoUrl}.html?colour${colorId}`,
        title,
        brand,
        image,
        productCode,
        selected: false,
        colorDescription,
        size: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize) !== '.' && (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize),
        collapsedComparePopup: true,
        gender,
        buyingGroup,
        productQualifier,
        brandValue,
    };
    return (_jsx(CheckboxWithLabel, { id: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, name: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, value: `product-compare-${compareProduct.productCode}-${compareProduct.color}`, checked: isCompareProduct, onChange: () => updateCompareList(compareProduct), align: CheckboxWithLabelVerticallyAlign.CENTER, labelChildren: isMobile && isCompareProduct && (compareItems === null || compareItems === void 0 ? void 0 : compareItems.length) > 1 ? (_jsx(Button, { text: t('productCompare.pdp.checkbox'), variant: ButtonVariant.OUTLINED_ALT, size: ButtonSize.XSMALL, shape: ButtonShape.PILL, iconRight: {
                name: IconName.CHEVRON_RIGHT,
                size: IconSize.MEDIUM,
            }, href: `${root}products/product-compare.html` })) : (t('product:productCompare.pdp.checkbox')) }));
};
const makeMapStateToProps = () => {
    const getCompareProductInformation = makeGetProductCompareInformation();
    const getIsCompareProduct = makeGetIsCompareProduct();
    const getSelectedSku = makeGetSelectedSku();
    const getCompareItems = makeGetCompareItems();
    const mapStateToProps = (state) => ({
        product: getCompareProductInformation(state),
        isCompareProduct: getIsCompareProduct(state),
        selectedSku: getSelectedSku(state),
        compareItems: getCompareItems(state),
    });
    return mapStateToProps;
};
const mapDispatchToProps = {
    updateCompareList: compareActions.createUpdateOnProductDetailPageAction,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(ProductCompareSelectorContainer);
